import axios from "axios";
import { API_BASE_URL } from "./baseUrl";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => {
    const data = response.data;
    if (data && data.status === "error") {
      return Promise.reject({
        message: data.message || "Something went wrong",
        data,
      });
    }
    return data;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    if (error.response?.status === 403) {
      // Geofence session lock — let the app shell raise the lockout overlay
      // immediately instead of waiting for the next 60s poll.
      if (error.response.data?.code === "GEOFENCE_LOCKED") {
        window.dispatchEvent(new CustomEvent("geofence:locked"));
      }
      return Promise.reject({
        message: error.response.data?.message || "You do not have permission to perform this action.",
        data: error.response.data,
      });
    }
    // Gateway failures return the web server's HTML error page, so
    // `data.message` is undefined and the user would otherwise see the bare
    // "Request failed with status code 504". Note there is deliberately no
    // global `timeout` on this instance — it also carries file uploads, which
    // legitimately run long on slow connections.
    if (
      error.code === "ECONNABORTED" ||
      [502, 503, 504].includes(error.response?.status)
    ) {
      return Promise.reject({
        message: "The server took too long to respond. Please try again in a moment.",
        data: error.response?.data,
        status: error.response?.status,
      });
    }

    return Promise.reject({
      message: error.response?.data?.message || error.message || "Network error",
      data: error.response?.data,
      status: error.response?.status,
    });
  },
);

export default api;
